import { useCallback, useMemo } from 'react';
import {
    PaymentDetailsRequest,
    PaymentPreferences,
    UserAccount,
    UserAvailabilityParams,
    UserAvailabilityResponse
} from './types';
import { useService } from '../common';

const API = {
    USER_ACCOUNTS: '/admin/users',
    USER_AVAILABLE: '/user/available',
    USER_SETTINGS: '/user/settings',
    USER_INFO: '/user/info',
};

export const useUserService = () => {
    const service = useService();
    const getAllUsers = useCallback((): Promise<UserAccount[]> => {
        return service.sendGetWithAuthorization(API.USER_ACCOUNTS)
            .then(service.handleResponse)
            .catch((error) => Promise.resolve(error));
    }, [service]);
    const getUserAvailable = useCallback((params: UserAvailabilityParams): Promise<UserAvailabilityResponse> => {
        const searchParams = new URLSearchParams({ ...params });
        return service.sendGetWithoutAuthorization(`${API.USER_AVAILABLE}?${searchParams.toString()}`)
            .then(service.handleResponse)
            .catch((error) => Promise.resolve(error));
    }, [service]);
    const updatePaymentDetails = useCallback((body: PaymentDetailsRequest): Promise<void> => {
        return service.sendPutWithAuthorization(API.USER_SETTINGS, body)
            .then(service.handleResponse)
            .catch((error) => Promise.resolve(error));
    }, [service]);
    const getUserInfo = useCallback((): Promise<PaymentPreferences> => {
        return service.sendGetWithAuthorization(API.USER_INFO)
            .then(service.handleResponse)
            .catch((error) => Promise.resolve(error));
    }, [service]);


    return useMemo(() =>
        ({
            getAllUsers,
            getUserAvailable,
            updatePaymentDetails,
            getUserInfo
        }),
        [
            getAllUsers,
            getUserAvailable,
            updatePaymentDetails,
            getUserInfo
        ]);
};